import moment from 'moment';
import errorHandle from '../../../utils/errorHandle';

import { orgPayouts, orgPayoutsCount, supOrgPayoutDetails } from '../../../api/supportAdmin';

export default async function orgPayoutsData(orgId, limit, offset, setPayoutData, setLoading, serviceType) {
    setLoading(true);

    try {
        const payoutData = await orgPayouts(orgId, limit, offset, serviceType);

        const includeDates =
            payoutData?.data?.length > 0
                ? payoutData.data.map((item) => {
                      const date = moment(item.payoutDate, 'YYYY-MM-DD');

                      let subtractDays = null;

                      // Keep existing date logic
                      if (date.day() === 1) {
                          subtractDays = 3;
                      } else if (date.day() === 5) {
                          subtractDays = 4;
                      }

                      const fromDate =
                          subtractDays !== null ? date.clone().subtract(subtractDays, 'days').format() : null;

                      const toDate = date.clone().subtract(1, 'days').format();

                      return {
                          ...item,
                          fromDate,
                          toDate
                      };
                  })
                : [];

        setPayoutData(includeDates);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
}

export const fetchMoreDetails = async (id, setMoreDetails, setLoading, serviceType) => {
    setLoading(true);

    try {
        const payoutData = await supOrgPayoutDetails(id, serviceType);

        setMoreDetails(payoutData.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const payoutCount = (orgId, setTotalCount, setLoading, serviceType) => {
    setLoading(true);

    orgPayoutsCount(orgId, serviceType)
        .then((res) => {
            setTotalCount(res.data.payoutsCount);
        })
        .catch((error) => {
            errorHandle(error);
        })
        .finally(() => {
            setLoading(false);
        });
};
